import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const GroupIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('GroupIcon', className)}
  >
    <path
      d="M17,22c-0.6,0-1-0.4-1-1v-2c0-1.7-1.3-3-3-3H5c-1.7,0-3,1.3-3,3v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2c0-2.8,2.2-5,5-5h8
	c2.8,0,5,2.2,5,5v2C18,21.6,17.6,22,17,22z"
    />
    <path d="M9,12c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S11.8,12,9,12z M9,4C7.3,4,6,5.3,6,7s1.3,3,3,3s3-1.3,3-3S10.7,4,9,4z" />
    <path
      d="M23,22c-0.6,0-1-0.4-1-1v-2c0-1.4-0.9-2.6-2.2-2.9c-0.5-0.1-0.9-0.7-0.7-1.2c0.1-0.5,0.7-0.9,1.2-0.7
	c2.2,0.6,3.7,2.6,3.8,4.8v2C24,21.6,23.6,22,23,22z"
    />
    <path
      d="M16,11.9c-0.4,0-0.9-0.3-1-0.8c-0.1-0.5,0.2-1.1,0.7-1.2c1.1-0.3,1.9-1.1,2.2-2.2c0.4-1.6-0.6-3.2-2.2-3.7
	C15.2,4,14.9,3.4,15,2.9c0.1-0.5,0.7-0.9,1.2-0.7c2.7,0.7,4.3,3.4,3.6,6.1c-0.5,1.8-1.8,3.2-3.6,3.6C16.2,11.9,16.1,11.9,16,11.9z"
    />
  </svg>
);

export default GroupIcon;
